import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { MendixClientCompartments, mendixClientStorageKey } from '..';

export class MendixClientListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(mendixClientStorageKey)
    private readonly cache: DataCache<MendixClientCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('mendixClientData');
        } else {
          this.cache.reset('mendixClientData');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
